export const transitionBaseMs = 200;
